// Polyfills for older browsers (Safari 11+, iOS Safari 11+)
import 'core-js/stable';
import 'regenerator-runtime/runtime';

import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
